import React from "react";
import Str from "shared/components/Str";
import classnames from "classnames";

class LearnMore extends React.Component {
	state = { open: false };
	popup = null;

	_open = () => {
		const settings = {
			height: 400,
			width: 550,
			top: 0,
			left: 0,
			toolbar: 0,
			location: 0,
			menubar: 0,
			directories: 0,
			scrollbars: 0,
		};
		const settingsStrings = [];
		let settingsString = "";

		// condense that shit
		Object.keys(settings || {}).forEach((name) => {
			const value = settings[name];
			settingsStrings.push(`${name}=${value}`);
		});

		settingsString = settingsStrings.join(", ");

		if (this.props.link) {
			this.popup = window.open(
				this.props.link,
				"learnmore",
				settingsString,
			);
		} else {
			this.setState({ open: true });
		}
	};

	_close = () => {
		if (!this.props.link) {
			this.setState({ open: false });
		}
	};

	render() {
		let learnMoreOpen;
		const classes = classnames({
			"okpay-learnmore": true,
		});

		if (this.state.open) {
			learnMoreOpen = (
				<div className="okpay-learnmore-open">
					<div
						className="okpay-learnmore-text"
						dangerouslySetInnerHTML={{ __html: this.props.children }}
					/>
					<button
						className="blue flatbutton okpay-learnmore-close"
						onClick={this._close}
					>
						Got it
					</button>
				</div>
			);
		}

		return (
			<div className="okpay-learnmore">
				<button className="okpay-learnmore-toggler" onClick={this._open}>
					<Str>Learn more</Str>
				</button>
				{learnMoreOpen}
			</div>
		);
	}
}

export default LearnMore;



// WEBPACK FOOTER //
// ./src/reflux/okpay/components/LearnMore.jsx